module.exports = __webpack_public_path__ + "img/cb-r-y1.8e7e4331.gif";